import './tradingPairModal.scss';

import { Dispatch, SetStateAction, useCallback } from 'react';

import { Button } from 'ui/Button/Button';
import { Modal } from 'ui/Modal/Modal';
import { RadioBox } from 'ui/RadioBox/RadioBox';
import { EExchange } from 'web3';

type ChoseTradingPairsProps = {
  onClose: () => void;
  openAddPairWindow: () => void;
  openSelectPairDex: () => void;
  typeTradingPair: EExchange;
  setTypeTradingPair: Dispatch<SetStateAction<EExchange>>;
};

export const TradingPairModal = ({
  onClose,
  openAddPairWindow,
  openSelectPairDex,
  typeTradingPair,
  setTypeTradingPair,
}: ChoseTradingPairsProps) => {
  const handleNext = useCallback(() => {
    if (typeTradingPair === EExchange.cex) {
      openAddPairWindow();
    }
    if (typeTradingPair === EExchange.dex) {
      openSelectPairDex();
    }
  }, [typeTradingPair, openAddPairWindow, openSelectPairDex]);

  return (
    <Modal
      title="New trading pair"
      onClose={onClose}
      className={'mm-trading-pair-modal'}
      customButtons={<Button onClick={handleNext}>Next</Button>}
    >
      <div className="mm-trading-pair-modal__trading_pair_container">
        <RadioBox
          text={'CEX'}
          checked={typeTradingPair === EExchange.cex}
          onChange={() => setTypeTradingPair(EExchange.cex)}
        />
        <RadioBox
          text={'DEX'}
          checked={typeTradingPair === EExchange.dex}
          onChange={() => setTypeTradingPair(EExchange.dex)}
        />
      </div>
    </Modal>
  );
};
